import { isEmpty } from "lodash";
import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import ApiSecCredentialsFormm from "./ApiSecCredentialsForm";
import ApiSecMappingForm from "./ApiSecMappingForm";

const ApiSecConfigLising = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Application",
        dataIndex: "applicationName",
        width: 130,
        render: columnRenderArrayData,
      },
      {
        title: "Instance",
        dataIndex: "instanceName",
        width: 130,
        render: (instanceId) =>
          isEmpty(instanceId) ? "All" : columnRenderArrayData(instanceId),
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={ApiSecMappingForm}
      CredentialsForm={ApiSecCredentialsFormm}
      extraColumns={columns}
    />
  );
};

export default ApiSecConfigLising;